const TEN = 10;
const ONE_HUNDRED = 100;
const ONE_THOUSAND = 1000;
const ONE_MILLION = 1000000;
const ONE_BILLION = 1000000000;           //         1.000.000.000 (9)
const ONE_TRILLION = 1000000000000;       //     1.000.000.000.000 (12)
const ONE_QUADRILLION = 1000000000000000; // 1.000.000.000.000.000 (15)
const MAX = 9007199254740992;             // 9.007.199.254.740.992 (15)

const LESS_THAN_TWENTY = [
    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
    'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
];

const TENTHS_LESS_THAN_HUNDRED = [
    'zero', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
];

const ENDS_WITH_DOUBLE_ZERO_PATTERN = /(hundred|thousand|(m|b|tr|quadr)illion)$/;
const ENDS_WITH_TEEN_PATTERN = /teen$/;
const ENDS_WITH_Y_PATTERN = /y$/;
const ENDS_WITH_ZERO_THROUGH_TWELVE_PATTERN = /(zero|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)$/;
const ordinalLessThanThirteen = {
    zero: 'zeroth',
    one: 'first',
    two: 'second',
    three: 'third',
    four: 'fourth',
    five: 'fifth',
    six: 'sixth',
    seven: 'seventh',
    eight: 'eighth',
    nine: 'ninth',
    ten: 'tenth',
    eleven: 'eleventh',
    twelve: 'twelfth'
};

const MAX_SAFE_INTEGER = 9007199254740991;

function between(high, low, value) {
  return (value >= low && value <= high);
}

function only(value) {
  var numberPattern = /[^0-9.]/g;
  return value.replace(numberPattern, "");
}

function words ( value, includeCents, camelCase )
{
  let cents = Math.floor((value - Math.floor( value ) + 0.009)* 100);
  value = Math.floor( value );

  let oneToTwenty = [ '', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ',
    'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen ' ];
  let tenth = [ '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety' ];
  let hundredth = [ '', 'hundred ', 'thousand', 'million' ];

  if ( value.toString().length > 7 ) return 'overlimit';
  
  let num = ( '0000000' + value ).slice( -7 ).match( /^(\d{1})(\d{1})(\d{2})(\d{1})(\d{2})$/ );
  if ( !num ) return;

  let outputText = num[ 1 ] !== 0 ? ( oneToTwenty[ Number( num[ 1 ] ) ] || `${ tenth[ num[ 1 ][ 0 ] ] } ${ oneToTwenty[ num[ 1 ][ 1 ] ] }` ) + (' ' + hundredth[3] + ' ') : '';  
  outputText += num[ 2 ] !== 0 ? ( oneToTwenty[ Number( num[ 2 ] ) ] || `${ tenth[ num[ 2 ][ 0 ] ] } ${ oneToTwenty[ num[ 2 ][ 1 ] ] }` ) + (hundredth[1] + ' ') : '';
  outputText += num[ 3 ] !== 0 ? ( oneToTwenty[ Number( num[ 3 ] ) ] || `${ tenth[ num[ 3 ][ 0 ] ] } ${ oneToTwenty[ num[ 3 ][ 1 ] ] }` ) + (' ' + hundredth[2] + ' ') : '';
  outputText += num[ 4 ] !== 0 ? ( oneToTwenty[ Number( num[ 4 ] ) ] || `${ tenth[ num[ 4 ][ 0 ] ] } ${ oneToTwenty[ num[ 4 ][ 1 ] ] }` ) + (hundredth[1] + ' ') : '';
  outputText += num[ 5 ] !== 0 ? ( oneToTwenty[ Number( num[ 5 ] ) ] || `${ tenth[ num[ 5 ][ 0 ] ] } ${ oneToTwenty[ num[ 5 ][ 1 ] ] } ` ) : '';

  if ( camelCase )
  {
    var __words = outputText.split( " " );
    var __output = [];

    __words.forEach( ( val ) =>
    {
      if ( val.length > 2 ) __output.push( val[ 0 ].toUpperCase() + val.substring( 1 ) );
    } );

    outputText = __output.join( " " );
  }
  return (outputText + (includeCents ? (" and " + cents + "/100") : ""));
}

function currency(value) {
  value =
    !value || value === undefined ? 0 : typeof value !== "number" ? 0 : value;
  return "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

function format(number, digits, decimalPlaces, withCommas) {
  number = !number || number === undefined ? 0 : number.toString();
  var simpleNumber = "";

  // Strips out the dollar sign and commas.
  for (var i = 0; i < number.length; ++i) {
    if ("0123456789.".indexOf(number.charAt(i)) >= 0)
      simpleNumber += number.charAt(i);
  }

  number = parseFloat(simpleNumber);

  if (isNaN(number)) number = 0;
  if (withCommas == null) withCommas = false;
  if (digits === 0) digits = 1;

  var integerPart = decimalPlaces > 0 ? Math.floor(number) : Math.round(number);
  var string = "";

  for (var j = 0; j < digits || integerPart > 0; ++j) {
    // Insert a comma every three digits.
    if (withCommas && string.match(/^\d\d\d/)) string = "," + string;

    string = (integerPart % 10) + string;
    integerPart = Math.floor(integerPart / 10);
  }

  if (decimalPlaces > 0) {
    number -= Math.floor(number);
    number *= Math.pow(10, decimalPlaces);

    string += "." + format(number, decimalPlaces, 0);
  }

  return string;
}


function generateWords(number) {
    var remainder, word,
        words = arguments[1];

    // We’re done
    if (number === 0) {
        return !words ? 'zero' : words.join(' ').replace(/,$/, '');
    }
    // First run
    if (!words) {
        words = [];
    }
    // If negative, prepend “minus”
    if (number < 0) {
        words.push('minus');
        number = Math.abs(number);
    }

    if (number < 20) {
        remainder = 0;
        word = LESS_THAN_TWENTY[number];

    } else if (number < ONE_HUNDRED) {
        remainder = number % TEN;
        word = TENTHS_LESS_THAN_HUNDRED[Math.floor(number / TEN)];
        // In case of remainder, we need to handle it here to be able to add the “-”
        if (remainder) {
            word += '-' + LESS_THAN_TWENTY[remainder];
            remainder = 0;
        }

    } else if (number < ONE_THOUSAND) {
        remainder = number % ONE_HUNDRED;
        word = generateWords(Math.floor(number / ONE_HUNDRED)) + ' hundred';

    } else if (number < ONE_MILLION) {
        remainder = number % ONE_THOUSAND;
        word = generateWords(Math.floor(number / ONE_THOUSAND)) + ' thousand,';

    } else if (number < ONE_BILLION) {
        remainder = number % ONE_MILLION;
        word = generateWords(Math.floor(number / ONE_MILLION)) + ' million,';

    } else if (number < ONE_TRILLION) {
        remainder = number % ONE_BILLION;
        word = generateWords(Math.floor(number / ONE_BILLION)) + ' billion,';

    } else if (number < ONE_QUADRILLION) {
        remainder = number % ONE_TRILLION;
        word = generateWords(Math.floor(number / ONE_TRILLION)) + ' trillion,';

    } else if (number <= MAX) {
        remainder = number % ONE_QUADRILLION;
        word = generateWords(Math.floor(number / ONE_QUADRILLION)) +
        ' quadrillion,';
    }

    words.push(word);
    return generateWords(remainder, words);
}

function makeOrdinal(words) {
    // Ends with *00 (100, 1000, etc.) or *teen (13, 14, 15, 16, 17, 18, 19)
    if (ENDS_WITH_DOUBLE_ZERO_PATTERN.test(words) || ENDS_WITH_TEEN_PATTERN.test(words)) {
        return words + 'th';
    }
    // Ends with *y (20, 30, 40, 50, 60, 70, 80, 90)
    else if (ENDS_WITH_Y_PATTERN.test(words)) {
        return words.replace(ENDS_WITH_Y_PATTERN, 'ieth');
    }
    // Ends with one through twelve
    else if (ENDS_WITH_ZERO_THROUGH_TWELVE_PATTERN.test(words)) {
        return words.replace(ENDS_WITH_ZERO_THROUGH_TWELVE_PATTERN, replaceWithOrdinalVariant);
    }
    return words;
}

function wordsCardinal(number) {
  var num = parseInt(number, 10);

  if (!isFinite(num)) {
    throw new TypeError(
      'Not a finite number: ' + number + ' (' + typeof number + ')'
    );
  }
  if (!isSafeNumber(num)) {
    throw new RangeError(
      'Input is not a safe number, it’s either too large or too small.'
    );
  }
  return generateWords(num);
}

function wordsOrdinal(number) { return makeOrdinal(wordsCardinal(number)); }

function replaceWithOrdinalVariant(match, numberWord) {
    return ordinalLessThanThirteen[numberWord];
}

function isSafeNumber(value) {
    return typeof value === 'number' && Math.abs(value) <= MAX_SAFE_INTEGER;
}

// Simplified https://gist.github.com/marlun78/885eb0021e980c6ce0fb
function isFinite(value) {
    return !(typeof value !== 'number' || value === Infinity || value === -Infinity);
}

module.exports = {
  only,
  currency,
  format,
  words,
  wordsOrdinal,
  wordsCardinal,
  between
};
